import { sendVerificationCodeToEmail } from '../signup';
import { useCountDown } from '../../../hooks/useTimer';

/**
 *
 * @param email takes user email
 * @description uses countDown under the hood and return isCounting and counter time to track  if it is safe to request new token
 */
export default function useEmailVerificationServices() {
  const { startCountDown, isCounting, counterTime } = useCountDown(3); //ONE MINUTES

  //THIS SENDS A TOKEN TO USER'S EMAIL
  const verifyWithEmail = async (email: string) => {
    try {
      if (isCounting) return;
      await sendVerificationCodeToEmail(email); //api request
      startCountDown();
    } catch (err: any) {
      console.error(err.message);
      throw err;
    }
  };

  return {
    isCounting,
    counterTime,
    verifyWithEmail,
    startCountDown,
  };
}
